module.exports = __webpack_public_path__ + "img/icon_image_add.ad8db78f.svg";